import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface StyledEditableFieldButtonProps {
  isConfirm?: boolean;
  isHidden?: boolean;
}
export const EditableFieldButton = styled.button<StyledEditableFieldButtonProps>`
  width: 32px;
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};
  height: 32px;
  margin-left: 8px;
  z-index: 1000;

  background: ${({ isConfirm }) =>
    isConfirm ? beam.color.primaryBlue : beam.color.pureWhite};
  border: none;
  /* small-shadow */
  box-shadow: ${({ isConfirm }) =>
    isConfirm
      ? '0 1px 4px rgba(19, 113, 254, 0.7)'
      : '0 1px 4px rgba(0, 0, 0, 0.161)'};
  border-radius: 8px;
`;

export const Icon = styled.img<StyledEditableFieldButtonProps>`
  color: ${({ isConfirm }) =>
    isConfirm ? beam.color.pureWhite : beam.color.pureBlack};
`;
